//  This is a generated file, do not edit it directly
import SvgIcon from '@mui/material/SvgIcon';
import type { TpBaseSvgIconProps } from '../types/muiSvgIcon';
import { SvgNotification } from '../icons/Notification';

export function NotificationIcon(props: TpBaseSvgIconProps): React.ReactElement {
  return (
    <SvgIcon {...props} component={SvgNotification} data-qa="NotificationIcon">
      <svg />
    </SvgIcon>
  );
}
